import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const microsoftSlice = createSlice({
  name: 'microsoft',
  initialState,
  reducers: {},
  extraReducers: () => {
    // No extra reducers needed for now
  },
});

export default microsoftSlice.reducer;
